import i18n from 'i18next'
import languageDetector from 'i18next-browser-languagedetector'

import { initReactI18next } from 'react-i18next'
import { localStorageGetItem } from 'src/utils/storage'

import { enGB, enUS, ptBR, esAR } from './langs'

const lng = localStorageGetItem('i18nextLng', 'pt-BR')

i18n
  .use(initReactI18next)
  .use(languageDetector)
  .init({
    resources: {
      'en-US': {
        translation: enUS,
      },
      'en-GB': {
        translation: enGB,
      },
      'pt-BR': {
        translation: ptBR,
      },
      'es-AR': {
        translation: esAR,
      },
    },
    lng,
    fallbackLng: 'en-US',
    debug: false,
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
  })

export default i18n
